<template>
  <el-row
    class="widget-col widget-view"
    type="flex"
    style="height: 100%"
    :style="{ width: element.options.width }"
    v-if="element && element.key"
    :class="{ active: selectWidget.key && selectWidget.key === element.key }"
    :key="element.key"
    @click.native.stop="handleSelectWidget(index)"
  >
    <el-container>
      <el-header class="sw-el-header" style="height: 50px">
        {{ element.name }}
        <div class="son-form-header-bt">
          <el-tooltip
            class="item"
            effect="dark"
            content="导入Excel文件数据"
            placement="top-start"
            v-if="element.options.importExcel"
          >
            <el-button
              type="primary"
              icon="el-icon-document-add"
              circle
            ></el-button>
          </el-tooltip>
          <!-- <el-tooltip class="item" effect="dark" content="增加" placement="top">
            <el-button type="primary" icon="el-icon-plus" circle></el-button>
          </el-tooltip> -->
          <el-tooltip
            class="item"
            effect="dark"
            :content="
              element.options.addBtnName ? element.options.addBtnName : '新增'
            "
            placement="top"
          >
            <el-button
              type="primary"
              icon="el-icon-plus"
              circle
              @click.prevent="handleAddRow"
            >
              <span v-if="element.options.addBtnName">{{
                element.options.addBtnName
              }}</span>
            </el-button>
          </el-tooltip>
        </div>
      </el-header>
      <el-main>
        <draggable
          v-model="element.list"
          v-bind="{
            group: { name: 'people', put: handlePut },
            ghostClass: 'ghost',
            animation: 200,
            handle: '.drag-widget',
          }"
          :no-transition-on-drag="true"
          @change="handleMoveEnd($event, element)"
          @add="handleWidgetSonFormAdd($event, element)"
          style="width: 100%"
        >
          <transition-group name="fade" tag="el-col" class="widget-col-list">
            <template v-for="(item, sonIndex) in element.list">
              <div
                v-if="element && element.list"
                :span="3"
                :key="sonIndex + 1"
                style="float: left"
              >
                <div class="son-form-herder" style="height: 30px">
                  <span v-if="item.options.required" style="color: #f56c84"
                    >*</span
                  >

                  <span class="sw-form-desc" v-if="item.options.customDesc">
                    <i class="el-icon-question"></i>
                  </span>

                  {{ item.name }}
                </div>
                <div class="son-form-content">
                  <advanced-form-item
                    v-if="
                      Object.keys(advancedComponents).indexOf(item.type) >= 0
                    "
                    :key="item.key"
                    :element="item"
                    :select.sync="selectWidget"
                    :index="sonIndex"
                    :data="element"
                    :data-config="dataConfig"
                    @select-change="handleSelectChange($event, element)"
                  >
                  </advanced-form-item>
                  <widget-form-item
                    v-else
                    :key="item.key"
                    :from-son-form="true"
                    :element="item"
                    :select.sync="selectWidget"
                    :index="sonIndex"
                    :data="element"
                    :data-config="dataConfig"
                    @select-change="handleSelectChange($event, element)"
                  >
                  </widget-form-item>
                </div>
              </div>
            </template>
          </transition-group>
        </draggable>
      </el-main>
    </el-container>
    <div
      class="widget-view-action widget-col-action"
      v-if="selectWidget.key === element.key"
    >
      <i class="el-icon-delete" @click.stop="handleWidgetDelete(index)"></i>
    </div>

    <div
      class="widget-view-drag widget-col-drag"
      v-if="selectWidget.key === element.key"
    >
      <i class="su-icon-tuodong drag-widget"></i>
    </div>
  </el-row>
</template>

<script>
import WidgetFormItem from '../../WidgetFormItem'
import { advancedComponents } from '../advanced.js'
import AdvancedFormItem from '../AdvancedFormItem'
import Draggable from 'vuedraggable'
import widgetFormUtils from '../../../util/widgetFormUtils'
export default {
  name: 'son-form',
  props: ['element', 'select', 'index', 'data', 'dataConfig'],
  components: {
    Draggable,
    WidgetFormItem,
    AdvancedFormItem,
  },
  data() {
    return {
      advancedComponents,
      selectWidget: this.select,
    }
  },
  methods: {
    handlePut(a, b, c) {
      if (c.className.indexOf('widget-un-son') >= 0) {
        return false
      }
      return true
    },
    handleMoveEnd() {},
    handleSelectWidget(index) {
      this.selectWidget = this.data.list[index]
      // console.log('SONFORM',JSON.stringify(this.selectWidget))
    },
    handleWidgetDelete(index) {
      if (this.data.list.length === 1) {
        this.$emit('select-change', -1)
      } else {
        if (this.data.list.length - 1 === index) {
          this.$emit('select-change', index - 1)
        } else {
          this.$emit('select-change', index)
        }
      }
      this.data.list.splice(index, 1)
    },
    handleWidgetSonFormAdd($event, row) {
      const newIndex = $event.newIndex
      const opt = row.list[newIndex].options
      opt.draftOverrideVisible = false
      if (Object.prototype.hasOwnProperty.call(opt, 'isShowSelect')) {
        opt.isShowSelect = false
      }
      if (
        Object.prototype.hasOwnProperty.call(opt, 'props') &&
        Object.prototype.hasOwnProperty.call(opt.props, 'cascadeList')
      ) {
        if (
          Object.prototype.hasOwnProperty.call(row.options, 'props') &&
          Object.prototype.hasOwnProperty.call(row.options.props, 'cascadeList')
        ) {
          opt.props.cascadeList = row.options.props.cascadeList
        }
      }
      widgetFormUtils.handleWidgetAdd(newIndex, null, row, this, true)
      this.selectWidget = row.list[newIndex]
    },
    handleSelectChange(index, item) {
      setTimeout(() => {
        index >= 0
          ? (this.selectWidget = item.list[index])
          : (this.selectWidget = {})
      }, 350)
    },
  },
  watch: {
    select(val) {
      this.selectWidget = val
    },
    selectWidget: {
      handler(val) {
        this.$emit('update:select', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.sw-el-header {
  background-color: #b5b5b52e;
  font-weight: bold;
  line-height: 40px;
}

.son-form-header-bt {
  margin-top: 4px;
  float: right;
}

.son-form-herder {
  border: 1px solid rgba(181, 181, 181, 0.38);
  background-color: #b5b5b52e;
  margin-top: 2px;
  text-align: center;
  font-weight: bold;
  line-height: 30px;
  margin-left: 2px;
}

.son-form-content {
  margin-left: -8px;
  margin-right: -10px;
}

.son-form-content .widget-view {
  width: 140px;
}

.widget-col-list {
  width: 100%;
  overflow-x: auto;
  display: flex;
}

::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 7px;
}
</style>
